import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Liiga palju katseid. Proovi paari minuti pärast uuesti.

  <span style="color:#85c1dc;">**FI:**</span>
  Liikaa yrityksiä. Yritä uudelleen muutaman minuutin kuluttua.

  <span style="color:#85c1dc;">**RU:**</span>
  Слишком много попыток. Повторите попытку через несколько минут.
*/
/* @__NO_SIDE_EFFECTS__ */
const m998 = msg(
  mf`Liiga palju katseid. Proovi paari minuti pärast uuesti.`,
  mf`Liikaa yrityksiä. Yritä uudelleen muutaman minuutin kuluttua.`,
  mf`Слишком много попыток. Повторите попытку через несколько минут.`,
)

export { m998 as 'w.basket.summary.voucher_too_many_attempts' }